import React from 'react';

import classes from './GeneralInfoTab.module.scss';
import { BodyMetricsWidget } from './BodyMetricsWidget/BodyMetricsWidget';
import { PersonalInfoWidget } from './PersonalInfoWidget/PersonalInfoWidget';

const GeneralInfoTab = () => {
  return (
    <div className={classes.container}>
      <BodyMetricsWidget />
      <PersonalInfoWidget />
    </div>
  );
};

export { GeneralInfoTab };
